import * as actionTypes from "../actions/actionTypes";

const initialState = {
  templates: [
    {
      id: 0,
      idCalculator: 0,
      nombre: "",
      description: "",
      descriptionAlternative: ""
    }
  ],
  products: [],
  selectedOption: "",
  currentTemplateID: 0,
  currentTemplateProducts: [],
  alternativesTemplateProducts: [],
  alternativesTemplateOptions: [],
  currentM2asked: 1,
  waste: 0.05
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_PRODUCTS:
      return {
        ...state,
        products: action.products.data
      };
    case actionTypes.SET_TEMPLATES:
      let aux = [];
      for (var i = 0; i < action.templates.data.length; i++) {
        aux.push({
          id: action.templates.data[i].id,
          idCalculator: action.templates.data[i].idCalculator,
          nombre: action.templates.data[i].nombre,
          description: action.templates.data[i].description,
          alternativeDescription: action.templates.data[i].alternativeDescription,
          products: []
        });
      }
      return {
        ...state,
        templates: [...aux]
      };
    case actionTypes.SET_TEMPLATEPRODUCTS:
      const aux2 = action.m2quantities.data.map(product => ({
        m2qty: product.m2Qty,
        prod: state.products.find(prod => product.idProduct === prod.id),
        hasAlternative: product.hasAlternative,
        isAlternativeProduct: product.isAlternativeProduct,
        idProductToReplace: product.idProductToReplace
      }));
      return {
        ...state,
        currentTemplateProducts: [...aux2],
        currentTemplateID: state.templates[action.templateID].id
      };
    case actionTypes.SET_ALTERNATIVEOPTIONS:
      const aux3 = action.alternativeOptions.data.map(alt => ({
        originalProduct: state.products.find(prod => alt.idProduct === prod.id),
        alternativeProduct: state.products.find(
          prod => alt.idAltProduct === prod.id
        )
      }));
      return {
        ...state,
        alternativesTemplateProducts: [...aux3]
      };
    case actionTypes.UPDATE_CURRENTTEMPLATEPRODUCTS:
      const aux4 = [...state.currentTemplateProducts];
      var indexOfAlternativeProduct = state.products.findIndex(
        i => i.id === action.alternativeProductID
      );
      aux4[action.positionToReplace].prod =
        state.products[indexOfAlternativeProduct];
      return {
        ...state,
        currentTemplateProducts: aux4
      };
    case actionTypes.SET_ALTERNATIVEOPTIONSTEMPlATE:
      const aux5 = action.alternativeOptionsTemplate.data.map(product => ({
        m2qty: product.m2Qty,
        prod: state.products.find(prod => product.idProduct === prod.id),
        hasAlternative: product.hasAlternative,
        isAlternativeProduct: product.isAlternativeProduct,
        idProductToReplace: product.idProductToReplace
      }));
      return {
        ...state,
        alternativesTemplateOptions: [...aux5]
      };
    case actionTypes.UPDATE_CURRENTTEMPLATEOPTIONS:
      const aux6 = [...state.alternativesTemplateOptions];
      var indexOfAlternativeProductOptions = state.products.findIndex(
        i => i.id === action.alternativeProductID
      );
      aux6[action.positionToReplace].prod =
        state.products[indexOfAlternativeProductOptions];
      return {
        ...state,
        alternativesTemplateOptions: aux6
      };
    default:
      return state;
  }
};

export default reducer;
